var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1497_1726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 34.8203V54.0003H37.18L33.18 50.0003H22V38.8203L18 34.8203Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.74 64.5799L64 58.7599V63.9999H8.00003V55.6999H12V52.4999H8.00003V39.1999H12V35.9999H8.00003V23.1999H12V19.9999H8.00003V8.81991L39.88 40.5199V34.8799L7.42003 2.57991C7.14029 2.29785 6.78289 2.10549 6.3934 2.02735C6.0039 1.94921 5.59996 1.98884 5.23307 2.14117C4.86618 2.2935 4.55297 2.55165 4.33337 2.88269C4.11377 3.21373 3.99772 3.60266 4.00003 3.99991V65.9999C4.00003 66.5303 4.21075 67.0391 4.58582 67.4141C4.96089 67.7892 5.4696 67.9999 6.00003 67.9999H68.32C68.7173 68.0022 69.1062 67.8862 69.4373 67.6666C69.7683 67.447 70.0264 67.1338 70.1788 66.7669C70.3311 66.4 70.3707 65.996 70.2926 65.6065C70.2144 65.2171 70.0221 64.8597 69.74 64.5799Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 59.9998H56C57.0609 59.9998 58.0783 59.5784 58.8284 58.8283C59.5786 58.0781 60 57.0607 60 55.9998V17.3998L55.4 8.93984C55.0442 8.32348 54.5305 7.8132 53.9117 7.46163C53.293 7.11006 52.5916 6.92994 51.88 6.93984C51.1523 6.94562 50.4399 7.14981 49.8197 7.53042C49.1994 7.91104 48.6947 8.45366 48.36 9.09984L44 17.4398V55.9998C44 57.0607 44.4214 58.0781 45.1716 58.8283C45.9217 59.5784 46.9391 59.9998 48 59.9998ZM48 18.3998L51.88 10.8598L56 18.4198V47.9998H48V18.3998ZM48 51.2598H56V56.1398H48V51.2598Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1497_1726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheory);
export default __webpack_public_path__ + "static/media/theory.f399b301db85e65cd48c90d9f263a86f.svg";
export { ForwardRef as ReactComponent };